export default class CardDataModel {
    constructor() {
        this.phoneNumber = '';
        this.driver = '';
        this.registrationNumber = '';
        this.odometerRead = '';
        this.mpk = '';
        this.phoneNumberCode = undefined;
        this.phoneNumberValue = '';
        this.vehicleType = undefined;
        this.acceptedTerms = {};
        this.limitedAccess = undefined;
        this.dontResume = undefined;
    }

    static assign(from, to) {
        if (from) {
            to.phoneNumber = from.phoneNumber ? from.phoneNumber : '';
            to.driver = from.driver ? from.driver : '';
            to.registrationNumber = from.registrationNumber ? from.registrationNumber : '';
            to.odometerRead = from.odometerRead ? from.odometerRead : '';
            to.mpk = from.mpk ? from.mpk : '';
            to.phoneNumberCode = from.phoneNumberCode ? from.phoneNumberCode : undefined;
            to.phoneNumberValue = from.phoneNumberValue ? from.phoneNumberValue : '';
            to.vehicleType = from.vehicleType ? from.vehicleType :  undefined;
            to.acceptedTerms = from.acceptedTerms ? from.acceptedTerms : undefined;
            to.limitedAccess = from.limitedAccess !== undefined ? from.limitedAccess : undefined;
            to.dontResume = from.dontResume !== undefined ? from.dontResume : false;
        } else {
            to = new CardDataModel();
        }
    }

    static copy(from) {
        const to = new CardDataModel();
        CardDataModel.assign(from, to);
        return to;
    }
}
